import { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import { LocalStorage } from './services/localStorage/LocalStorage.services'

import NavBar from './components/NavBar/NavBar'
import NavBar2 from './components/NavBar/NavBar2'
import Footer from './components/Footer/Footer'
import Home from './views/Home/Home'
import Companies from './views/Companies/Companies'
import NewCompany from './views/Companies/NewCompany'
import Labels from './views/Labels/Labels'
import NewLabel from './views/Labels/NewLabel'
import Arees from './views/Arees/Arees'
import NewArea from './views/Arees/NewArea'
import Professionals from './views/Professionals/Professionals'
import NewProfessional from './views/Professionals/NewProfessional'
import Tasks from './views/Tasks/Tasks'
import NewTask from './views/Tasks/NewTask'
import Tipus from './views/Tipus/Tipus'
import NewTipus from './views/Tipus/NewTipus'
import Serveis from './views/Serveis/Serveis'
import NewServei from './views/Serveis/NewServei'
import Daily from './views/Tasks/Daily'
import Actions from './views/Actions/Actions'
import Calendar from './views/Tasks/Calendar'
import LoginPage from './views/Login/LoginPage'

import getProfessionalById from './services/professionals/getProfessionalById'

import styles from './App.module.css'

const App = () => {

  let location = useLocation()
  const professionalProfile = LocalStorage.getItem("professionalProfile")
  const professionalId = LocalStorage.getItem("id")

  const [ professional, setProfessional ] = useState(null)

  useEffect(() => {
    if(professionalId) {
      getProfessionalById(professionalId)
      .then(professional => {
        if (professional === null) {
            setProfessional("Usuari no trobat")
        } else {
          const professionalName = professional && professional.professionalName + " " + professional.professionalLastName1 + " " + professional.professionalLastName2
          setProfessional(professionalName)
        }
      })
    } else {
      setProfessional(null)
    }
  },[professionalId])


  const handleLogout = () => {
    LocalStorage.clear()
  }

  return (
    <div className={styles.container}>
          {
            location.pathname !== "/" && location.pathname !== "/login" &&
            <header className={styles.headerSi}>
              <NavBar professionalProfile={professionalProfile} handleLogout={handleLogout} professionalName={professional}></NavBar>
            </header>
          }
          <main className={styles.general_main}>
            {
              location.pathname !== "/" && location.pathname !== "/login" &&
              <div className={styles.sidebar}> 
                <NavBar2 professionalProfile={professionalProfile} ></NavBar2>
              </div>
            }
            <div className={styles.content}>
              <Routes>
                <Route path="/" element={<Navigate to='/login'></Navigate>}></Route>
                <Route path="/login" element={<LoginPage ></LoginPage>}/>
                <Route path="/home" element={<Home></Home>}/>
                <Route path="/empreses/">
                  <Route index element={<Companies></Companies>}/>
                  <Route path="new-empresa" element={<NewCompany></NewCompany>}/>
                  <Route path=":id" element={<NewCompany></NewCompany>}/>
                </Route>
                <Route path="/serveis/">
                  <Route index element={<Serveis></Serveis>}/>
                  <Route path="new-servei" element={<NewServei></NewServei>}/>
                  <Route path=":id" element={<NewServei></NewServei>}/>
                </Route>
                <Route path="/projectes/">
                  <Route index element={<Arees></Arees>}/>
                  <Route path="new-projecte" element={<NewArea></NewArea>}/>
                  <Route path=":id" element={<NewArea></NewArea>}/>
                </Route>
                <Route path="/professionals">
                  <Route index element={<Professionals></Professionals>}/>
                  <Route path="new-professional" element={<NewProfessional></NewProfessional>}/>
                  <Route path=":id" element={<NewProfessional></NewProfessional>}/>
                </Route>
                <Route path="/etiquetes">
                  <Route index element={<Labels></Labels>}/>
                  <Route path="new-etiqueta" element={<NewLabel></NewLabel>}/>
                  <Route path=":id" element={<NewLabel></NewLabel>}/>
                </Route>
                <Route path="/tipus">
                  <Route index element={<Tipus></Tipus>}/>
                  <Route path="new-tipus" element={<NewTipus></NewTipus>}/>
                  <Route path=":id" element={<NewTipus></NewTipus>}/>
                </Route>
                <Route path="/tasques">
                  <Route index element={<Tasks professional={professionalId}></Tasks>}/>
                  <Route path="new-tasca" element={<NewTask professional={professionalId}></NewTask>}/>
                  <Route path="daily" element={<Daily professional={professionalId}></Daily>}/>
                  <Route path=":id" element={<NewTask></NewTask>}/>
                  <Route path="calendari" element={<Calendar professional={professionalId}></Calendar>}/>
                </Route>
                <Route path="/accions">
                  <Route index element={<Actions></Actions>}/>
                </Route>
              </Routes>
            </div>
          </main>
          <footer>
            <Footer></Footer>
          </footer> 
    </div>
  )
}

export default App